<template>
  <div class="img-modal">
    <img
      class="img-modal__img"
      :src="src"
      :alt="alt"
      :title="title"
      @load="loading = false"
    />
    <AppLoading v-if="loading" position="center" />
  </div>
</template>

<script>
import { asyncModal } from "@/components/ui/modal/utils";

const ImgModal = {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ""
    },
    title: String
  },
  data: () => ({
    loading: true
  })
};

export function openImage({ src, title, alt }) {
  return asyncModal({
    name: "image-modal",
    component: ImgModal,
    titled: false,
    props: {
      src,
      title,
      alt
    }
  });
}

export default ImgModal;
</script>

<style lang="scss">
.modal.image-modal {
  width: auto;
  .modal-card {
    max-width: 100%;
    padding: 0px;
  }
  .modal__close {
    top: -35px;
    right: 0;
  }

  .app-background {
    display: none;
  }
}
.img-modal {
  display: table;
  margin: 0 auto;
  &__img {
    max-width: 90vw;
    max-height: 90vh;
    min-width: 10vw;
    min-height: 10vh;
    margin: 0 auto;
    display: block;
  }
}
</style>
